<template>
  <a ref="preview" :href="offer.url" target="_self" class="map__preview map-preview">
    <div class="map-preview__image">
      <picture class="map-preview__picture">
        <img :src="offer.image" :alt="offer.title" />
      </picture>
      <favorite-button :offer-id="offer.id" :offer-title="offer.title"></favorite-button>
      <div v-if="offer.distance" class="map__distance">{{ offer.distance | distance }}</div>
    </div>
    <div class="map-preview__content">
      <img class="map-preview__icon-type" :src="offer.typeIcon" :alt="offer.type" />
      <div class="map-preview__subtitle" v-html="offer.fairgroundTitle" />
      <div class="map-preview__title" v-html="offer.title"></div>
      <div class="map-preview__detail-page">{{ translateDetail }}</div>
      <google-link :maps="maps" :center="offer.center || undefined"></google-link>
      <div class="map-preview__top-icons">
        <img v-for="top in offerTops" :key="top" class="map-preview__icon-top" :src="tops[top].icon" :alt="top" />
      </div>
    </div>
  </a>
</template>

<script>
import FavoriteButton from '../components/FavoriteButton.vue';
import GoogleLink from '../components/GoogleLink.vue';

export default {
  name: 'TeaserPreview',
  components: { FavoriteButton, GoogleLink },
  props: {
    offer: {
      type: Object,
      required: true,
    },
    maps: {
      type: String,
      required: true,
    },
    translateDetail: {
      type: String,
      required: true,
    },
    tops: {
      type: Object,
      required: true,
    },
  },
  computed: {
    offerTops() {
      return this.offer.top.filter((top) => top.icon).slice(0, 3);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.preview.removeAttribute('target');
    });
  },
};
</script>
